import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=79247622&"
import script from "./topbar.vue?vue&type=script&lang=ts&"
export * from "./topbar.vue?vue&type=script&lang=ts&"
import style0 from "./topbar.vue?vue&type=style&index=0&id=79247622&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports